<template>
  <div id="more-serve">
    <div class="more-title">
      <div class="title-content">
        {{ this.$t("lang.BetterMedicalCare.moreExclusiveServices") }}
      </div>
    </div>
    <div class="more-background">
      <div class="detail-list">
        <el-row :gutter="18">
          <el-col v-for="item of detailList" :key="item.id" :span="6"
            ><div :class="languageItem" class="detail-list-item">
              <h3 :class="languageTitle" class="item-title">
                {{ item.title }}
              </h3>
              <p :class="languageContent" class="item-content">
                {{ item.content }}
              </p>
            </div></el-col
          >
        </el-row>
      </div>
    </div>
    <div class="product">
      <h3 class="product-title">优诊通服务项目及价格表</h3>
      <el-button @click="handleTitleClick" type="primary">点击查看</el-button>
      <el-dialog
        title="价格表"
        :visible.sync="dialogVisible"
        width="90%"
        :before-close="handleClose"
      >
        <div class="product-image" @click="dialogVisible = true">
          <img src="../../assets/images/bestMedicalCare/jiagebiao.png" alt="" />
        </div>
        <div class="zhu">
          <span>注：</span>
          <p>
            1.
            表中标价格为单独购买某项服务的项目市场单价，最终费用以实际收费价格为准。
          </p>
          <p>
            2.
            表中价格仅为协调资源及相关咨询的服务费用；用户就诊过程中产生的挂号费、手术费、诊疗费、住院费等一切费用，由用户自行承担
          </p>
          <p>
            3.
            表中“专家”特指国际知名医疗机构医学专家和国内三甲医院副主任级（含）以上医学专家。
          </p>
          <p>
            4. 远程会诊、电话咨询等项目的有效咨询时间不低于20分钟/次。
          </p>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="dialogVisible = false"
            >关闭</el-button
          >
        </span>
      </el-dialog>
    </div>
    <div class="product">
      <h3 class="product-title jihuoliucheng">激活流程</h3>
      <div class="product-image">
        <img
          src="../../assets/images/bestMedicalCare/jihuo.png"
          style="width: 75%"
          alt=""
        />
      </div>
    </div>
    <div class="product">
      <h3 class="product-title">预约流程</h3>
      <div class="product-image">
        <img
          src="../../assets/images/bestMedicalCare/yuyue.png"
          style="width: 75%"
          alt=""
        />
      </div>
      <el-button @click="goBack" class="go-back" type="primary">{{
        this.$t("lang.top")
      }}</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "MoreServe",
  data() {
    return {
      dialogVisible: false,
      languageItem: "",
      languageTitle: "",
      languageContent: ""
    };
  },
  mounted() {
    let detailLists = document.getElementsByClassName("detail-list-item");
    let itemContents = document.getElementsByClassName("item-content");
    let itemTitles = document.getElementsByClassName("item-title");
    if (this.$i18n.locale === "en-US") {
      for (let i = 0; i < detailLists.length; i++) {
        detailLists[i].style.height = "285px";
        itemContents[i].style.fontSize = "14px";
        itemContents[i].style.lineHeight = "16px";
        itemTitles[i].style.fontSize = "16px";
      }
    }
    this.setStyle();
  },
  beforeUpdate() {
    this.setStyle();
  },
  computed: {
    detailList() {
      return [
        {
          id: 1,
          title: this.$t("lang.BetterMedicalCare.accompanyDuring"),
          content: this.$t("lang.BetterMedicalCare.accompanyDuringDetail")
        },
        {
          id: 2,
          title: this.$t("lang.BetterMedicalCare.psychologicalCounseling"),
          content: this.$t(
            "lang.BetterMedicalCare.psychologicalCounselingDetail"
          )
        },
        {
          id: 3,
          title: this.$t("lang.BetterMedicalCare.pickUp"),
          content: this.$t("lang.BetterMedicalCare.pickUpDetail")
        },
        {
          id: 4,
          title: this.$t("lang.BetterMedicalCare.takeRecords"),
          content: this.$t("lang.BetterMedicalCare.takeRecordsDetail")
        },
        {
          id: 5,
          title: this.$t("lang.BetterMedicalCare.doctorsOnline"),
          content: this.$t("lang.BetterMedicalCare.doctorsOnlineDetail")
        },
        {
          id: 6,
          title: this.$t("lang.BetterMedicalCare.doctorsPhone"),
          content: this.$t("lang.BetterMedicalCare.doctorsPhoneDetail")
        },
        {
          id: 7,
          title: this.$t("lang.BetterMedicalCare.nutritionistsOnline"),
          content: this.$t("lang.BetterMedicalCare.nutritionistsOnlineDetail")
        },
        {
          id: 8,
          title: this.$t("lang.BetterMedicalCare.weightOnline"),
          content: this.$t("lang.BetterMedicalCare.weightOnlineDetail")
        }
      ];
    }
  },
  methods: {
    handleTitleClick() {
      this.dialogVisible = true;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    goBack() {
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    },
    setStyle() {
      if (this.$i18n.locale === "en-US") {
        this.languageItem = "detail-list-item-us";
        this.languageTitle = "item-title-us";
        this.languageContent = "item-content-us";
      } else if (this.$i18n.locale === "zh-CN") {
        this.languageItem = "detail-list-item";
        this.languageTitle = "item-title";
        this.languageContent = "item-content";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/global";
#more-serve {
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
  .more-background {
    height: 760px;
    width: 100%;
    background: url("../../assets/images/bestMedicalCare/more.png") center
      no-repeat;
    background-size: 90% 80%;
    overflow: hidden;
    .detail-list {
      width: 860px;
      margin: 50px auto;
      .detail-list-item {
        height: 257px;
        width: 200px;
        margin-bottom: 47px;
        box-shadow: -2px 7px 21px 3px rgba(130, 195, 255, 0.17);
        overflow: hidden;
        background: #ffffff;
        border-radius: 5px;
        .item-title {
          margin: 20px 0;
          height: 20px;
          font-size: 22px;
          color: $publicBlue;
          text-align: center;
        }
        .item-content {
          margin: 0 10px;
          word-break: break-all;
          color: #bcbcbc;
          font-size: 16px;
          line-height: 20px;
        }
      }
      .detail-list-item-us {
        height: 290px;
        width: 200px;
        margin-bottom: 47px;
        box-shadow: -2px 7px 21px 3px rgba(130, 195, 255, 0.17);
        overflow: hidden;
        background: #ffffff;
        border-radius: 5px;
        .item-title-us {
          margin: 20px 0;
          height: 20px;
          font-size: 16px;
          color: $publicBlue;
          text-align: center;
        }
        .item-content-us {
          margin: 0 10px;
          word-break: break-all;
          color: #bcbcbc;
          font-size: 14px;
          line-height: 16px;
        }
      }
    }
  }
  .product {
    position: relative;
    .jihuoliucheng {
      margin-top: 50px;
    }
    text-align: center;
    .product-title {
      text-align: center;
      font-size: 20px;
      color: #363636;
      margin-bottom: 10px;
    }
    .product-image {
      margin-bottom: 20px;
      img {
        width: 100%;
      }
      &:hover {
        cursor: pointer;
      }
    }
    .zhu {
      width: 860px;
      margin: 0 auto;
      font-size: 12px;
      color: #a7a7a7;
      text-align: left;
      span {
        margin-left: 20px;
      }
      p {
        margin-left: 40px;
        line-height: 20px;
      }
    }
  }
}
.title-content {
  font-size: 20px;
  color: #363636;
  margin: 0 50px;
  text-align: center;
}
.go-back {
  /*position: absolute;*/
  margin-bottom: 30px;
}
</style>
